<form class="edit-profile-form" #profileForm="ngForm">
  <h1 mat-dialog-title>{{ dialogTitle }}</h1>
  <div class="dropzone" fileDragDrop (filesChangeEmiter)="onFileChange($event)">
    <div class="text-wrapper">
      <div class="centered">
        <input type="file" name="file" id="file" (change)="onFileChange($event.target.files)" multiple>
        <label for="file">
          <ng-container *ngIf="!url">
            <mat-icon>cloud_upload</mat-icon>
            <div>Upload Image</div>
            <div class="allowed-filetypes">SVG, PNG, JPG, or GIF (max 3MB)</div>
          </ng-container>
          <ng-container *ngIf="url">
            <img [src]="url" height="150"> 
            <div class="allowed-filetypes">REPLACE IMAGE</div>
          </ng-container>
        </label>
      </div>
    </div>
  </div>

  <div fxLayout="column">
    <mat-form-field class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
      <mat-label>First Name</mat-label>
      <input type="text" matInput placeholder="First Name" name="firstName" [(ngModel)]="firstName"
        #firstNameInput="ngModel" required>
    </mat-form-field>
    <mat-form-field class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
      <mat-label>Last Name</mat-label>
      <input type="text" matInput placeholder="Last Name" name="lastName" [(ngModel)]="lastName"
        #lastNameInput="ngModel" required>
    </mat-form-field>
    <mat-form-field class="mat-form-field-no-margin" appearance="outline" floatLabel="always">
      <mat-label>E-mail</mat-label>
      <input type="text" matInput placeholder="E-mail" name="email" [(ngModel)]="email"
        #emailInput="ngModel" required pattern="[^\s@]+@[^\s@]+\.[^\s@]+">
    </mat-form-field>
    <div fxFlex fxFlex="row-wrap" style="margin-bottom: 8px;">
      <div fxFlex fxFlex="row">
          <button
          *ngIf="data && data.uuid"
          mat-button
          color="primary"
          (click)="resendPasswordChange()"
          >
          Resend Password Change E-mail
          </button>
          <div class="mat-form-field-element" *ngIf="(data && data.uuid || email)" fxLayout="column" fxLayoutAlign="center center">
            <mat-checkbox *ngIf="(data && data.uuid)"
              [(ngModel)]="email_domain_approved"
              (ngModelChange)="onApproveEmail()"
              name="email_domain_approved"
            >
                Approve Email
            </mat-checkbox>          
            <mat-checkbox *ngIf="!(data && data.uuid)"
              [(ngModel)]="email_domain_approved"
              [disabled]="!email || emailInput.errors"
              name="email_domain_approved">
                Approve E-mail
            </mat-checkbox>      
          </div>
          <div class="mat-form-field-element" *ngIf="adminApproved">
            <mat-icon color="primary">check</mat-icon>
            Account has been approved.
          </div>
      </div>
      <div fxFlex fxFlex="row">
        <button
          *ngIf="data && data.uuid"
          mat-button
          color="primary"
          (click)="resendVerification()"
        >
          Resend Verification E-mail
        </button>
        <div *ngIf="data && data.uuid" fxLayout="column" fxLayoutAlign="center center">
          <div class="mat-form-field-element" *ngIf="data && data.uuid" fxLayout="row">
            <mat-icon 
              *ngIf="emailVerified" 
              color="primary">
              check
            </mat-icon>
            <mat-icon *ngIf="!emailVerified" color="warn">close</mat-icon>
            <div>&nbsp;E-mail Verified</div>
          </div>
        </div>
      </div>     
    </div>
  </div>
  <div fxLayout="row">
    <mat-form-field class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
      <mat-label>Rank</mat-label>
      <input type="text" matInput placeholder="Rank" name="rank" [(ngModel)]="rank">
    </mat-form-field>
    <div fxFlex></div>
    <mat-form-field appearance="outline">
      <mat-label>ROLES</mat-label>
      <mat-select multiple [(ngModel)]="selectedRoles" [compareWith]="compareRolesFn" name="selectedRoles" required>
        <mat-option *ngFor="let role of allRoles" [value]="role">{{ role.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="errors">
    <mat-error *ngIf="firstNameInput.errors">
      First name required.
    </mat-error> 
    <mat-error *ngIf="lastNameInput.errors">
      Last name required.
    </mat-error>
    <mat-error *ngIf="emailInput.errors && emailInput.errors.required">
      E-mail required.
    </mat-error>
    <mat-error *ngIf="emailInput.errors && emailInput.errors.pattern">
      Invalid e-mail address format.
    </mat-error>
  </div>

  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="profileForm.invalid">Save <span *ngIf="!data">&amp; E-mail Verification</span></button>
  </div>
</form>
